<script setup>
import { ref } from 'vue'

const props = defineProps({
    list: {
        type: Array,
        default: () => [],
    },
    visible: {
        type: Number,
        default: 6,
    },
    more: {
        type: Number,
        default: 5,
    },
    max: {
        type: [Number, Boolean],
        default: false,
    },
    getFc: {
        type: Function,
        default: null,
        required: true,
    },
    updateFc: {
        type: Function,
        default: null,
        required: true,
    },
    id: {
        type: [String, Number],
        default: '',
        required: true,
    },
})

const visibleAdjusted = ref(props.visible)

function showMore() {
    props.getFc(props.id, props.more, visibleAdjusted.value)

    props.updateFc()

    visibleAdjusted.value += props.more
}
</script>

<template>
    <div
        v-if="list.length >= visibleAdjusted && (max ? list.length < max : true)"
        class="load-more-button"
    >
        <BaseButton
            variant="tertiary"
            size="m"
            trailing-icon="arrow-down"
            @click="showMore"
        >Load More</BaseButton>
    </div>
</template>

<style lang="scss" scoped>
@use '@design' as *;

.load-more-button {
    margin-top: $space-24;
    text-align: right;
}
</style>
